import { useMutation } from "@tanstack/react-query"
import { websiteAuthService } from "@/api/websiteAuthService"
import { toast } from "sonner"
import { useNavigate } from "react-router-dom"

export const useLogout = () => {
  const navigate = useNavigate()

  return useMutation({
    mutationFn: websiteAuthService.logout,
    onSuccess: () => {
      localStorage.removeItem("website_token")
      localStorage.removeItem("customer")
      toast.success("Logged out successfully")
      navigate("/login")
    },
    onError: (error: any) => {
      // Even if API fails, clear local storage
      localStorage.removeItem("website_token")
      localStorage.removeItem("customer")
      toast.error(error?.message || "Failed to logout")
      navigate("/login")
    },
  })
}
